import { useEffect, useState } from "react";
import { Controller, Navigation, Pagination } from "swiper";
import { Swiper } from "swiper/react";

import styles from "./SwiperItem.module.scss";

export const SwiperItem = ({
  children,
  swiperRef,
  prevRef,
  nextRef,
  autoHeight,
  paginationWrapper,
}) => {
  const pagination = {
    el: `.${paginationWrapper}`,
    clickable: true,
    type: "fraction",
    renderFraction: (currentClass, totalClass) => {
      return `<span class="${currentClass} ${styles["pagination-current"]}"></span><span class="${totalClass}"></span>`;
    },
  };

  const [_, setInit] = useState(null);

  useEffect(() => {
    swiperRef.current.controller.control = swiperRef.current;
    swiperRef.current.controller.control = swiperRef.current;
  }, [swiperRef]);

  return (
    <Swiper
      modules={[Navigation, Pagination, Controller]}
      observer={true}
      pagination={pagination}
      navigation={{
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }}
      onInit={() => {
        setInit(true);
      }}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
      }}
      watchOverflow={false}
      slidesPerView={1}
      slidesPerGroup={1}
      loop={true}
      autoHeight={autoHeight}
      onSwiper={(swiper) => {
        swiperRef.current = swiper;
      }}
      allowTouchMove={false}
    >
      {children}
    </Swiper>
  );
};

export default SwiperItem;
